import { useEffect, useState } from 'react'
import LinkButton from '../../elements/LinkButton/LinkButton'
import { ELEMENT_SIZE, Flex } from 'mixtiles-web-common'
import * as S from './LoginBox.styles'
import { useAuth } from 'services/AuthProvider/AuthProvider'
import { translateManager as t } from '../../services/TranslateManager'
import { LOGGED_OUT_PARAM } from '../../services/LoginUtills'
import fallbackPhotoUrl from '../../images/account.png'
import { generateLetterAvatar } from './avatarCreator'
import useSignOut from '../../hooks/useSignOut'

export default function LoggedInContent() {
  const { user } = useAuth()
  const { signOut } = useSignOut()
  const [photoUrl, setPhotoUrl] = useState(
    (user && user.picture) || generateLetterAvatar(user?.email)
  )
  const username = user ? user.email : 'username'

  useEffect(() => {
    if (user?.picture) {
      setPhotoUrl(user.picture)
    } else {
      setPhotoUrl(generateLetterAvatar(user?.email) || fallbackPhotoUrl)
    }
  }, [user])

  const onImageLoadError = () => {
    setPhotoUrl(generateLetterAvatar(user?.email) || fallbackPhotoUrl)
  }

  const onLogoutClicked = () =>
    signOut({
      returnToUrl: `${window.location.origin}/?${LOGGED_OUT_PARAM}=1`,
      source: 'Menu',
    })

  return (
    <Flex data-testid="menu-logged-in-content">
      <S.UserPhoto>
        <img src={photoUrl} onError={onImageLoadError} />
      </S.UserPhoto>
      <S.Content>
        <S.Username>{username}</S.Username>
        <LinkButton
          size={ELEMENT_SIZE.small}
          color="black"
          onClick={onLogoutClicked}
          data-testid="menu-logout-button"
        >
          {' '}
          {t.get('login.sign_out')}{' '}
        </LinkButton>
      </S.Content>
    </Flex>
  )
}
